(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["images-with-textes"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    class Slider {
        constructor() {
            this.figcaptions = document.querySelectorAll('figure figcaption');
            this.paginationDot = document.querySelector('.pagination span.active');
            this.currentIndex = 0;
            this.transformIndex = 0;
            this.dotIndex = 0;
            
            // Configuration
            this.transforms = this.getTransforms();
            this.dotWidths = [
                '57px',
                '83px',
                '109px',
                '134px',
                '31px'
            ];
            
            // Init
            this.init();
        }
        
        getTransforms() {
            return window.innerWidth < 990 ? [
                'translate(10%, -20%)',
                'translate(10%, 30%)',
                'translate(10%, 10%)'
            ] : [
                'translate(-50%, 10%)',
                'translate(-50%, 100%)',
                'translate(-50%, -80%)'
            ];
        }
        
        updateSlider() {
            // Reset and set active class
            this.figcaptions.forEach(fig => fig.classList.remove('active'));
            this.figcaptions[this.currentIndex].classList.add('active');
            
            // Apply transforms
            this.figcaptions.forEach(fig => {
                fig.style.transform = this.transforms[this.transformIndex];
            });
            
            // Update dot width
            if (this.paginationDot) {
                this.paginationDot.style.width = this.dotWidths[this.dotIndex];
            }
            
            // Update indices
            this.currentIndex = (this.currentIndex + 1) % this.figcaptions.length;
            this.transformIndex = (this.transformIndex + 1) % this.transforms.length;
            this.dotIndex = (this.dotIndex + 1) % this.dotWidths.length;
        }
        
        init() {
            // Handle window resize
            window.addEventListener('resize', () => {
                this.transforms = this.getTransforms();
            });
            
            // Start slider
            setInterval(() => this.updateSlider(), 5000);
        }
    }
    
    // Initialize slider
    new Slider();
});

  } catch(e) { console.error(e); }
})();
})();
